import {HttpClient} from '@angular/common/http';


export abstract class ItemsService {
    
    static readonly API_URL: string = '/services/api/';
    
    static readonly ROOT_URL: string = '/';

    constructor(private http: HttpClient) {}
    
    abstract getServiceName() : string;
    
    getItems() {
        return this.http.get<any>(ItemsService.API_URL + this.getServiceName())
            .toPromise()
            .then(res => <any[]> res);
    }

    getItem(id:string) {
        return this.http.get<any>(ItemsService.API_URL+this.getServiceName()+'/'+id)
            .toPromise()
            .then(res => <any[]> res);
    }

    create(item: any) {
        return this.http.post(ItemsService.API_URL+this.getServiceName(), item)
            .toPromise()
            .then(res => res);
    }
    edit(item: any) {
        return this.http.post(ItemsService.API_URL+this.getServiceName(), item)
            .toPromise()
            .then(res => res);
    }
    removeItem(item: any) {
        return this.http.delete(ItemsService.API_URL+this.getServiceName()+'/' + item.id)
            .toPromise()
            .then(res => res);
    }
    removeItems(items: any[]) {
        return this.http.post(ItemsService.API_URL+this.getServiceName()+'/remove', items)
            .toPromise()
            .then(res => res);
    }
    desactiveItems(items: any[]) {
        return this.http.post(ItemsService.API_URL+this.getServiceName()+'/state/desactive', items)
            .toPromise()
            .then(res => res);
    }
    activeItems(items: any[]) {
        return this.http.post(ItemsService.API_URL+this.getServiceName()+'/state/active', items)
            .toPromise()
            .then(res => res);
    }
    

}
